import { motion } from "framer-motion";
import ApplicationTracker from "./ApplicationTracker";
import IDVerificationTracker from "./IDVerificationTracker";
import clsx from "clsx";
import { isMobileDevice } from "@/lib/util";

export default function Sidebar(props: any) {
  return (
    <>
      <div>
        <div style={{ overflow: 'hidden' }}
          id="docs-sidebar"
          className="hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 left-0 bottom-0 z-[60] w-64 bg-white border-r border-gray-200 pt-7 pb-10 overflow-y-auto scrollbar-y sm:block sm:translate-x-0 sm:right-auto sm:bottom-0"
        >
          <motion.div className="px-6 max-md:hidden"
            key={0}
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <a
              className="flex-none text-xl font-semibold dark:text-white mx-auto"
              href="https://www.meridiancu.ca"
              aria-label="Brand"
              target="_blank"
              style={{ width: '80%', display: 'block' }}
            >
              <img
                src="./assets/Meridian_Logo_Blue.svg"
                alt="Meridian"
                width={150}
                height={25}
              />
            </a>
          </motion.div>
          {props.type == 1 &&
            <motion.div
              key={1}
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <ApplicationTracker isJoint={props.isJoint} />
            </motion.div>
          }
          {props.type == 2 && <IDVerificationTracker />}
          <motion.div
            key={2}
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ opacity: 0 }}
            className={clsx("w-full text-start p-3 absolute bottom-4", (screen.height < 450 || isMobileDevice()) ? "hidden" : "")} role="region" aria-label="Side Navigation Footer">
            <p className="text-sm ml-2 underline"><a target="_blank" href="https://www.meridiancu.ca/about-meridian/privacy-and-security?_gl=1*11lr0k1*_ga*MTA5MzU5NzM4NS4xNjg4MDQ2ODM4*_ga_6D78MN23LS*MTY4ODA0NjgzOC4xLjEuMTY4ODA0Njg3Ni4yMi4wLjA">Privacy Statement</a></p>
            <p className="text-sm ml-2 underline"><a target="_blank" href="https://www.meridiancu.ca/about-meridian/legal/website-terms-of-use">Terms & Conditions</a></p>
            <p className="text-sm ml-2">&copy; 2025 Meridian Credit Union.</p>
          </motion.div>
        </div>
      </div>
    </>
  );
}
